import { render, staticRenderFns } from "./SelectPaxesSection.vue?vue&type=template&id=2eb83044&scoped=true&"
import script from "./SelectPaxesSection.vue?vue&type=script&lang=js&"
export * from "./SelectPaxesSection.vue?vue&type=script&lang=js&"
import style0 from "./SelectPaxesSection.vue?vue&type=style&index=0&id=2eb83044&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb83044",
  null
  
)

export default component.exports